// App config — all values come from the env file loaded by the npm script
// (.env.dev for `npm start`, .env.prod for `npm run build`). REACT_APP_* vars
// are baked into the public bundle at build time (so they are NOT secret).
const env = {
  API_URL: process.env.REACT_APP_API_URL || "",
  APP_URL: process.env.REACT_APP_APP_URL || "",
  REDIRECT_BASE: process.env.REACT_APP_REDIRECT_BASE || "",
  APP_HOST: process.env.REACT_APP_APP_HOST || "",
  DOCS_URL: process.env.REACT_APP_DOCS_URL || "",
  GHL_BILLING_URL: process.env.REACT_APP_GHL_BILLING_URL || "",
  GHL: {
    APP_ID: process.env.REACT_APP_GHL_APP_ID || "",
    CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID || "",
    CLIENT_SECRET: process.env.REACT_APP_GHL_CLIENT_SECRET || "",
    // SSO secret intentionally NOT here — decryption happens server-side.
  },
};

export default env;
